
import { Vue, Component, Prop, Ref, Watch } from 'vue-property-decorator';

import RequestItem from './RequestItem.vue';

import { ConsultationRequest, ConsultationStatus } from '@/types/consultations';
import { Maybe } from '@/types/common';

let isSelectionCancelDisabled = false;

const SELECTION_CANCEL_TIMEOUT = 100;

@Component({
    components: {
        RequestItem,
    }
})
export default class RequestList extends Vue {
    @Prop({ default: () => [] }) requests!: ConsultationRequest[];
    @Prop({ default: null }) selectedRequest!: Maybe<ConsultationRequest>;

    @Ref() list!: Vue;

    get hasSelectedRequest()    {
        return Boolean(this.selectedRequest);
    }

    // we don't need to check for every outside click, since user selects slot by clicking in the calendar
    // so we just check for clicks inside the list
    // but there are 2 caveats:
    // 1. selecting a request is a click, it propagates after vue updated its model,
    // so the `selectedRequest` is already exists in this component
    // which means adding listener inside watch doesn't work, since it will catch that click anyway
    // 2. clicks inside popup should be ignored, since they're part of a workflow
    mounted() {
        this.list.$el.addEventListener('click', this.cancelSelection);
    }
    
    beforeDestroy() {
        this.list.$el.removeEventListener('click', this.cancelSelection);
    }

    // 
    @Watch('hasSelectedRequest')
    disableSelectionCancelTemporary(selected: boolean) {
        if (selected) {
            // 1. instead of adding listener in watch, we add a little delay
            // so if click is catched before that timeout, it won't trigger closing request
            isSelectionCancelDisabled = true;

            setTimeout(() => {
                isSelectionCancelDisabled = false
            }, SELECTION_CANCEL_TIMEOUT);
        }
    }

    isSelected(request: ConsultationRequest) {
        if (!this.selectedRequest) {
            return false;
        }

        return this.selectedRequest.id === request.id;
    }

    selectRequest(request: ConsultationRequest) {
        this.$emit('select', request);
    }

    preventDeselection() {
        // 2. when request is selected, click also fires from list
        // calling .stopPropagation prevents deselection when user clicks something inside popup
    }

    cancelSelection() {
        if (!this.hasSelectedRequest || isSelectionCancelDisabled) {
            return;
        }

        this.$emit('deselect');
    }

    confirmRequest(request: ConsultationRequest) {
        this.$emit('confirm', request);
    }

    updateStatus(request: ConsultationRequest, status: ConsultationStatus) {
        this.$emit('update:status', {
            request,
            status,
        })
    }
}
